import { render, staticRenderFns } from "./TargetForm.vue?vue&type=template&id=1b8e1f90"
import script from "./TargetForm.vue?vue&type=script&lang=js"
export * from "./TargetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports